import React, { useContext } from "react";
import { Button } from "@mui/material";
import TransportHistoriesPopup from "../order/TransportHistoriesPopup";
import { useAppState } from "../../states/app-state";
import FavouritePlacesList from "../favouritePlaces/FavouritePlacesList";
// import LoginPopup from "../login/LoginPopup"; commented by Bearer Web Developer (not needed)
import PaymentMethod from "../price/PaymentMethod";
import styles from './MenuDrawer.module.scss'; // added by Bearer Web Developer
// import BusinessName from "./businessName"; // added and later removed for individual by Bearer Web Developer
// import ReservedOrdersPopup from "../reservedOrdersPopup"; // added and later removed for individual by Bearer Web Developer
import { observer } from "mobx-react-lite"; // added by Bearer Web Developer
import { AccessingFeatureMenuContext } from "../../states/contexts/accessingFeatureMenu"; // added by Bearer Web Developer

// this component modified by Bearer Web Developer
const MenuDrawer: React.FC = observer(() => { // observer added by Bearer Web Developer

    const appState = useAppState();
    const login = appState.login.loggedin;
    React.useEffect(() => {
        appState.getWebAppRemoteConfigParameters();
    }, [appState]);

    const [transportHistoryOpen, setTransportHistoryOpen] = React.useState(false);
    const handleTransportHistory = () => {
        setTransportHistoryOpen(true);
    }
    const handleTransportHistoryClose = () => {
        setTransportHistoryOpen(false);
    }
    // added and later removed for individual by Bearer Web Developer start (reservedOrders state)
    // const { reservedOrdersOpen, setReservedOrdersOpen } = appState?.ReservedOrders;
    // const handleReservedOrders = () => {
    //     setReservedOrdersOpen(true);
    // }
    // const handleReservedOrdersClose = () => {
    //     setReservedOrdersOpen(false);
    // }
    // added and later removed for individual by Bearer Web Developer end (reservedOrders state)
    const [paymentMethodOpen, setPaymentMethodOpen] = React.useState(false);
    // const handlePaymentMethod = () => {
    //     setPaymentMethodOpen(true);
    // }
    const handlePaymentMethodClose = () => {
        setPaymentMethodOpen(false);
    }
    // removed by Bearer Web Developer (not needed) start
    // const [logInPopupOpen, setLogInPopupOpen] = React.useState(false);
    // const handleLoginInPopupClose = () => {
    //     setLogInPopupOpen(false);
    // }
    // removed by Bearer Web Developer (not needed) end
    const [favouritePlacesListOpen, setFavouritePlacesListOpen] = React.useState(false);
    const handleFavouritePlacesList = () => {
        if (!appState.login.loggedin) {
            appState.login.setOpen(true); // modified by Bearer Web Developer (login state is moved to loginState of mobx states)
        } else {
            setFavouritePlacesListOpen(true);
        }
    }
    const handleFavouritePlacesListClose = () => {
        setFavouritePlacesListOpen(false);
    }
    //  added by Bearer Web Developer start
    const { setAccessingFeatureMenuElement } = useContext(AccessingFeatureMenuContext);
    const handleOpenVerificationMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (!appState?.login?.loggedin) {
            setAccessingFeatureMenuElement(event?.currentTarget);
        }
    }
    //  added by Bearer Web Developer end
    //  modified by Bearer Web Developer start
    return (
        <div className={styles.root}>
            {/* <LoginPopup open={logInPopupOpen} handleClose={handleLoginInPopupClose} /> */} {/* removed by Bearer Web Developer (not needed, we need one Login Popup component for every where of app) */}
            {/* the following log modified by Bearer Web Developer */}
            <FavouritePlacesList onSelect={(v) => { console.log(v) }} open={favouritePlacesListOpen} handleClose={handleFavouritePlacesListClose} />
            {/* added by Bearer Web Developer start  */}
            {
                login &&
                <>
                    <Button
                        onClick={handleTransportHistory}
                        disableRipple={true}
                        className={styles.button}>
                        <span className={styles.icon}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                <path d="M12.458 20.125V16.2917C12.1705 15.2694 11.6634 14.5148 10.9367 14.0276C10.2099 13.5405 9.4153 13.2969 8.5528 13.2969C8.37711 13.2969 8.20141 13.3089 8.02572 13.3328C7.85002 13.3568 7.67433 13.3847 7.49863 13.4167L9.00801 14.95L7.66634 16.2917L3.83301 12.4583L7.66634 8.625L9.00801 9.96667L7.49863 11.5C7.64238 11.4681 7.79412 11.4441 7.95384 11.4281C8.11356 11.4122 8.28127 11.4042 8.45697 11.4042C9.15974 11.4042 9.86252 11.512 10.5653 11.7276C11.2681 11.9432 11.899 12.2986 12.458 12.7937V6.54062L10.9247 8.07396L9.58301 6.70833L13.4163 2.875L17.2497 6.70833L15.908 8.05L14.3747 6.54062V20.125H12.458Z" fill="#FCFCFC" />
                            </svg>
                        </span>
                        <span>Order History</span>
                    </Button>
                    <Button
                        onClick={handleFavouritePlacesList}
                        disableRipple={true}
                        className={styles.button}>
                        <span className={styles.icon}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                <path d="M2.625 20.125V6.125C2.625 5.64375 2.79635 5.23177 3.13906 4.88906C3.48177 4.54635 3.89375 4.375 4.375 4.375H13.125C13.6062 4.375 14.0182 4.54635 14.3609 4.88906C14.7036 5.23177 14.875 5.64375 14.875 6.125V20.125L8.75 17.5L2.625 20.125ZM4.375 17.4562L8.75 15.575L13.125 17.4562V6.125H4.375V17.4562ZM16.625 17.5V2.625H5.25V0.875H16.625C17.1062 0.875 17.5182 1.04635 17.8609 1.38906C18.2036 1.73177 18.375 2.14375 18.375 2.625V17.5H16.625Z" fill="#FCFCFC" />
                            </svg>
                        </span>
                        <span>Saved Addresses</span>
                    </Button>
                    {/* Reserved Orders Button added and later removed for individual by Bearer Web Developer */}
                </>
            }
            {
                !login &&
                <>
                    <Button
                        onClick={handleOpenVerificationMenu} // added by Bearer Web Developer
                        disabled={!login} // modified by Bearer Web Developer
                        className={styles.button}>
                        <span className={styles.icon}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                <path d="M12.458 20.125V16.2917C12.1705 15.2694 11.6634 14.5148 10.9367 14.0276C10.2099 13.5405 9.4153 13.2969 8.5528 13.2969C8.37711 13.2969 8.20141 13.3089 8.02572 13.3328C7.85002 13.3568 7.67433 13.3847 7.49863 13.4167L9.00801 14.95L7.66634 16.2917L3.83301 12.4583L7.66634 8.625L9.00801 9.96667L7.49863 11.5C7.64238 11.4681 7.79412 11.4441 7.95384 11.4281C8.11356 11.4122 8.28127 11.4042 8.45697 11.4042C9.15974 11.4042 9.86252 11.512 10.5653 11.7276C11.2681 11.9432 11.899 12.2986 12.458 12.7937V6.54062L10.9247 8.07396L9.58301 6.70833L13.4163 2.875L17.2497 6.70833L15.908 8.05L14.3747 6.54062V20.125H12.458Z" fill="#FCFCFC" />
                            </svg>
                        </span>
                        <span>Order History</span>
                    </Button>
                    <Button
                        onClick={handleOpenVerificationMenu} // added by Bearer Web Developer
                        disabled={!login} // modified by Bearer Web Developer
                        className={styles.button}>
                        <span className={styles.icon}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                <path d="M2.625 20.125V6.125C2.625 5.64375 2.79635 5.23177 3.13906 4.88906C3.48177 4.54635 3.89375 4.375 4.375 4.375H13.125C13.6062 4.375 14.0182 4.54635 14.3609 4.88906C14.7036 5.23177 14.875 5.64375 14.875 6.125V20.125L8.75 17.5L2.625 20.125ZM4.375 17.4562L8.75 15.575L13.125 17.4562V6.125H4.375V17.4562ZM16.625 17.5V2.625H5.25V0.875H16.625C17.1062 0.875 17.5182 1.04635 17.8609 1.38906C18.2036 1.73177 18.375 2.14375 18.375 2.625V17.5H16.625Z" fill="#FCFCFC" />
                            </svg>
                        </span>
                        <span>Saved Addresses</span>
                    </Button>
                    {/* Reserved Orders Button added and later removed for individual by Bearer Web Developer */}
                </>
            }
            {/* <BusinessName /> */} {/* added by Bearer Web Developer */} {/* removed for individual by Bearer Web Developer */}
            {/* added by Bearer Web Developer end  */}
            {appState.login.loggedin &&
                <>
                    <PaymentMethod open={paymentMethodOpen} handleClose={handlePaymentMethodClose} />
                    {/* <SettingPopup open={editSettingOpen} handleClose={handleEditSettingClose} /> */} {/* commented by Bearer Web Developer  */}
                    <TransportHistoriesPopup open={transportHistoryOpen} handleClose={handleTransportHistoryClose} />
                    {/* <ReservedOrdersPopup open={reservedOrdersOpen} handleClose={handleReservedOrdersClose} /> */} {/* added and later removed for individual by Bearer Web Developer */}
                </>
            }
        </div>
    );
    //  modified by Bearer Web Developer end
})
export default MenuDrawer;



